export var recipientCellBox = {
  '& > p': {
    marginBottom: '0.2em'
  },
  '& > a': {
    display: 'block',
    marginBottom: '0.2em'
  }
};
export var detailsBtn = {
  padding: '0.6em',
  '& > i': {
    margin: 0
  }
};